import { AxiosInstance } from "axios"
import { ResourceBooking } from "./userResourceBookingTypes"
import { ServiceResponse } from "../../../../../core/api/apiTypes"

export enum UpcomingOrdersResourceBooking {
    UPCOMING_ORDERS_RESOURCE_BOOKING = "upcoming-orders-for-user",
}

export type FetchUserResourceBookingResponse = Readonly<{
    orders: ResourceBooking[]
}>

type FetchUserResourceBookingParams = Readonly<{
    userId: number
    startDate?: string
    endDate?: string
    period?: string
}>

export async function fetchUserResourceBooking(
    { userId, ...rest }: FetchUserResourceBookingParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchUserResourceBookingResponse> {
    const url = `/users/${userId}/upcoming/bookings`

    const response = await axios.get(url, {
        params: rest,
        signal,
    })

    return response.data
}

type DeleteBookingParams = Readonly<{
    bookingId: number
}>

export async function deleteBooking(
    { bookingId }: DeleteBookingParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.delete(`/orders/${bookingId}`, {
        signal,
    })
    return data
}
